import { defineStore } from 'pinia'
import { DomainApi } from '../test-api/index.ts'
import handleApiError from '../utils/handleApiError'

const domainApi = new DomainApi({}, '/api/v2')

const state = () => ({
  loading: true,
  domains: []
});

// functionName: (state, getters, rootState) => {}
const getters = {};

// functionName ({ commit, state, dispatch }, param, ...) {}
const actions = {
  async loadDomains() {
    this.loading = true
    const domainsResponse = await handleApiError(() => domainApi.domainList())
    this.domains = domainsResponse.data
    this.loading = false
  },
};

export default defineStore({
  id: 'bcDomain',
  state,
  getters,
  actions,
})
